import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { QUERY_KEYS } from '@hero/constants';
import { contactServices } from '@hero/services';
import { useNotification } from '@hero/store/hooks';

export const useRemoveTag = options => {
  const queryClient = useQueryClient();
  const { showSuccess } = useNotification();
  const { t } = useTranslation();

  return useMutation(id => contactServices.removeTag(id), {
    ...options,
    onSuccess() {
      showSuccess({
        message: t('successfullyRemovedMessage', {
          name: 'The tag'
        }),
        type: 'toast'
      });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.useGetTagListKey] });
    }
  });
};
